<template>
  <div id="app">
    <loading :isShow="showOrNot" @startAni="onStartAni" />
    <page-one :isShow="showOrNot" :myAniFlag="aniFlag" @triggerBGM="onTriggerBGM" />
    <page-input :isShow="showOrNot" @sendName="onSendName" @hvDirective="hvPlay" />
    <page-two :isShow="showOrNot" :person="userName" @hvDirective="hvPlay" :idx1="index1" :idx2="index2" :idx3="index3" :selectedOne="selected" :title="myTitle"/>
    <!-- <music-player :isShow="showOrNot" :mFlag="musicFlag" /> -->
    <rotate-it />
  </div>
</template>

<script>
import Rotate from './components/rotate/Rotate';
import MusicPlayer from './components/musicplayer/music-player';
import Loading from './pages/loading/loading';
import PageOne from './pages/page-one/pageOne';
import PageInput from './pages/page-input/pageInput';
import PageTwo from './pages/page-two/pageTwo';

export default {
  name: 'app',
  components: {
    Loading,
    'rotate-it': Rotate,
    'music-player': MusicPlayer,
    'page-one': PageOne,
    'page-two': PageTwo,
    'page-input': PageInput
  },
  data () {
    return {
      userName: '',
      index1: 80,
      index2: 82,
      index3: 70,
      selected: 6,
      myTitle: '创新天才',
      musicFlag: false,
      showOrNot: {
        isLDShow: true,
        isKVShow: false,
        isPOShow: false,
        isPIShow: false,
        isPTShow: false,
      },
      m001URL: 'https://www.jiandoukeji.com/h5/2018/guoke2018/music/wave.mp3',
      m002URL: 'https://www.jiandoukeji.com/h5/2018/guoke2018/music/lightning.mp3',
      m003URL: 'https://www.jiandoukeji.com/h5/2018/guoke2018/music/walk.mp3',
      m004URL: 'https://www.jiandoukeji.com/h5/2018/guoke2018/music/birds.mp3',
      m005URL: 'https://www.jiandoukeji.com/h5/2018/guoke2018/music/machine.mp3',
      m006URL: 'https://www.jiandoukeji.com/h5/2018/guoke2018/music/btn.mp3',
      aniFlag: false
    }
  },
  methods: {
    onTriggerBGM () {
      this.musicFlag = !this.musicFlag;
    },
    onSendName (msg) {
      const titles = ['好奇宝宝', '自带锦鲤', '创新天才'];
      const rn = this.genRandom(0, 3);
      const rs = this.genRandom(0, 8);
      let r1 = 83;
      let r2 = 83;
      let r3 = 83;
      switch (rn) {
        case 1:
          r1 = this.genRandom(90, 99);
          r2 = this.genRandom(60, 80);
          r3 = this.genRandom(60, 80);
          break;
        case 2:
          r2 = this.genRandom(90, 99);
          r1 = this.genRandom(60, 80);
          r3 = this.genRandom(60, 80);
          break;
        case 3:
          r3 = this.genRandom(90, 99);
          r2 = this.genRandom(60, 80);
          r1 = this.genRandom(60, 80);
          break;
        default:
          r1 = this.genRandom(80, 99);
          r2 = this.genRandom(80, 80);
          r3 = this.genRandom(80, 80);
          break;
      }
      this.userName = msg;
      this.index1 = r1;
      this.index2 = r2;
      this.index3 = r3;
      this.selected = rs;
      this.myTitle = titles[rn - 1];
    },
    genRandom (n1, n2) {
      let diff = n2 - n1;
      let addNum = Math.floor(Math.random() * diff) + 1;
      let result = n1 + addNum;
      return result;
    },
    onStartAni () {
      this.aniFlag = true;
    },
    _initMusic (id) {
      let audio = document.getElementById(id);
      // audio.volume = 0
      audio.play();
      document.addEventListener('WeixinJSBridgeReady', function () {
        audio.play();
      }, false);

      setTimeout(() => {
        audio.pause();
        document.addEventListener('WeixinJSBridgeReady', function () {
          audio.pause();
        }, false);
      }, 20);
    },
    _initAllMusic () {
      for (let i = 1; i < 7; i++) {
        let myId = `m0${i}`;
        this._initMusic(myId);
      }
    },
    hvPlay (data) {
      let musicName = data.name;
      let audio = document.getElementById(musicName);
      audio.play();
      document.addEventListener('WeixinJSBridgeReady', function () {
        audio.play();
      }, false);
    }
  },
  mounted () {
    // this._initAllMusic();
  }
}
</script>

<style lang='less'>
@import './assets/reset.less';
#app {
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: #000;
}

#myP {
  width: 100%;
  canvas {
    width: 100%;
  }
}
</style>
